import useDealShortId from '@/hooks/use-deal-short-id';
import { useDealByShortId } from '@/hooks/use-deals-selectors';
import useHubs from '@/hooks/use-hubs';
import { isEmpty } from 'lodash';
import React, { createContext, useContext, useMemo } from 'react';
interface DealContextType {
  currentShortId: string | null;
  hubPathIdentifier: string | null;
  isArchivedDeal: boolean;
}

const DealContext = createContext<DealContextType | undefined>(undefined);

export const DealProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { shortId } = useDealShortId();
  const { hubPathIdentifier } = useHubs();
  const deal = useDealByShortId(shortId);
  const isArchivedDeal = !isEmpty(deal?.archived_at);

  const value = useMemo<DealContextType>(
    () => ({
      currentShortId: shortId ?? null,
      hubPathIdentifier: hubPathIdentifier ?? null,
      isArchivedDeal,
    }),
    [shortId, hubPathIdentifier, isArchivedDeal],
  );

  return <DealContext.Provider value={value}>{children}</DealContext.Provider>;
};

export const useDealContext = () => {
  const ctx = useContext(DealContext);
  if (!ctx)
    throw new Error('useDealContext must be used within a DealProvider');
  return ctx;
};
